import { render, staticRenderFns } from "./AddCategoryOtherDialog.vue?vue&type=template&id=5418b5d0&scoped=true"
import script from "./AddCategoryOtherDialog.vue?vue&type=script&lang=js"
export * from "./AddCategoryOtherDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryOtherDialog.vue?vue&type=style&index=0&id=5418b5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418b5d0",
  null
  
)

export default component.exports